// Merchants pick their own brand colour, so the text that sits on it can't be
// hardcoded. Pick whichever of white or ink has more contrast.
export const DEFAULT_BRAND = "#1f2937";
const INK = "#15181e";

export const isHex = (v: string) => /^#[0-9a-f]{6}$/i.test(v);

export function safeBrand(v: string | null | undefined): string {
  return v && isHex(v) ? v.toLowerCase() : DEFAULT_BRAND;
}

function luminance(hex: string): number {
  const [r, g, b] = [1, 3, 5].map((i) => {
    const c = parseInt(hex.slice(i, i + 2), 16) / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrast(a: string, b: string): number {
  const [hi, lo] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (hi + 0.05) / (lo + 0.05);
}

export function onColor(bg: string): "#ffffff" | typeof INK {
  return contrast(bg, "#ffffff") >= contrast(bg, INK) ? "#ffffff" : INK;
}
